export default __webpack_public_path__ + "static/media/joker1_mobile.44b1d20a.jpg";